module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCA4IDgiIGZpbGw9Im5vbmUiPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNCAwQzMuNDQ3NzIgMCAzIDAuNDQ3NzE1IDMgMVYzSDFDMC40NDc3MTUgMyAwIDMuNDQ3NzIgMCA0QzAgNC41NTIyOCAwLjQ0NzcxNSA1IDEgNUgzVjdDMyA3LjU1MjI4IDMuNDQ3NzIgOCA0IDhDNC41NTIyOCA4IDUgNy41NTIyOCA1IDdWNUg3QzcuNTUyMjggNSA4IDQuNTUyMjggOCA0QzggMy40NDc3MiA3LjU1MjI4IDMgNyAzSDVWMUM1IDAuNDQ3NzE1IDQuNTUyMjggMCA0IDBaIiBmaWxsPSIjMTcxNzE3Ii8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/icon/plus.svg
// module id = 1500
// module chunks = 180